export const SCHEDULE_VIEWS = {
  CALENDAR: "calendar",
  MAP: "map",
  LIST: "list",
};
